import { Directive, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Directive({
  selector: '[iqCloseDialog]'
})
export class CloseDialogDirective {

  constructor( private matDialogRef: MatDialogRef<any, any> ) { }

  @HostListener('click', ['$event'])
  onclick( event: Event ) {
    this.matDialogRef.close();
  }
}
